import moment from "moment";
import appConfig from "./config/appConfig";

const trimTrailingSlash = (value) => {
  if (!value) return "";
  return value.replace(/\/+$/, "");
};

export const appEnv = appConfig.env || "local";
export const isServerEnv = appEnv !== "local";

export const apiUrl = appConfig.apiBaseUrl || "https://localhost:7050/api";

export const rooturl = apiUrl.replace(/\/api\/?$/i, "");

export const baseurl =appConfig.baseurl || "http://localhost:3000";

export const legacyDocumentUrl = appConfig.legecity_document_path;

export const caseDocumentUrl = trimTrailingSlash(
  appConfig.caseDocumentUrl || apiUrl + "/document/download",
);

export const legacity_document_path = legacyDocumentUrl;
export const primarySite = baseurl;
export const primary_doc_file = baseurl + "/CaseDocuments";
export const docUrl = rooturl + "/resources/";

export const pay4it_key = appConfig.pay4it_key || "TEST-Key-670664575316be1f4dc68994";
export const payment_callback = baseurl + "/confirm-pay";
export const payment_callback_internal = baseurl + "/confirm-internal";
export const Motion_Application_Substituted_Service = 14;
export const Motion_Application_Default_Judgement = 15;
//document.documentElement.setAttribute('data-theme', 'dark'); //change Theme to dark
export const SettleGazetteLine_ADR=appEnv=='local'?1084:972;
export const SettleGazetteLine=appEnv=='local'?1068:463;

export const SignatureGazetteLine_ADR=appEnv=='local'?1084:873;
export const SignatureGazetteLine=appEnv=='local'?1068:334;

export const lastSpecified = "52500.00"; //casetype_component 736

export const CFO_Placeholders = new Set([12, 24, 26, 27, 65]);

export const paystack_public =appConfig.paystack_public || "pk_test_657c8b8312c24ace7419a954beac2b8f4c43e65f";
export const Affidavit_Role_id = 6;
export const Legal_Role_id = 1;
export const Non_Legal_Role_id = 2;
export const Default_State = 15; //lagos
export const ClaimantType = 1;
export const DefendantType = 4;
export const PAGESIZE = 10;

// Judges are addressed as "Hon. Justice {name}" whenever no suffix is set on their profile.
export const JUDGE_TITLE = "Hon. Justice";
const KNOWN_TITLES = [
  "hon. justice", "hon justice", "hon.", "hon ", "justice", "mr", "mrs", "miss", "dr", "chief", "engr",
  "alhaji", "alhaja", "rev", "pastor", "admiral", "general", "air comm", "captain", "lt. col",
  "bishop", "arch bishop", "primate", "architect",
];
// judge object {suffix, firstName, lastName} -> "Hon. Justice Ade Bello" (or "{suffix} Ade Bello")
export const judgeName = (j, fallback = "") => {
  if (!j) return fallback;
  const name = [j.firstName, j.lastName].filter((x) => x && String(x).trim()).join(" ").trim();
  if (!name) return fallback;
  const suffix = (j.suffix || "").trim();
  return `${suffix || JUDGE_TITLE} ${name}`;
};
// a judge name the server already put together -> adds "Hon. Justice" when it starts with no title
export const judgeTitle = (fullName, fallback = "") => {
  const name = (fullName || "").trim();
  if (!name) return fallback;
  const lower = name.toLowerCase();
  const titled = KNOWN_TITLES.some((t) => lower.startsWith(t.endsWith(" ") ? t : t + " ") || lower.startsWith(t + "(") || lower === t);
  return titled ? name : `${JUDGE_TITLE} ${name}`;
};

export const CategoryList = [
  { id: 1, title: "GENERAL CIVIL" },
  { id: 2, title: "LANDS" },
  { id: 6, title: "FAMILY AND PROBATE (DIVORCE, PURE PROBATE AND CUSTODY)" },
  { id: 14, title: "BAIL APPLICATION" },
  { id: 7, title: "FUNDAMENTAL HUMAN RIGHT" },
  { id: 15, title: "GRANTING LEAVE TO FILE DIVORCE" },
  { id: 16, title: "JUDICIAL REVIEW" },
  { id: 3, title: "CRIMINAL" },
  { id: 3, title: "CRIMINAL" },
  { id: 4, title: "COMMERCIAL" },
  { id: 9, title: "MORTGAGES AND REVENUE" },
];
export const formatDateTime = (inputDateTime) => {
  const options = {
    day: "2-digit",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  };

  const formattedDateTime = new Intl.DateTimeFormat("en-US", options).format(
    new Date(inputDateTime),
  );
  return formattedDateTime;
};
export const formatDate = (inputDateTime) => {
  const options = {
    day: "2-digit",
    month: "long",
    year: "numeric",

    hour12: true,
  };

  const formattedDateTime = new Intl.DateTimeFormat("en-US", options).format(
    new Date(inputDateTime),
  );
  return formattedDateTime;
};
export const formatTime = (inputDateTime) => {
  const options = {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  };

  const formattedDateTime = new Intl.DateTimeFormat("en-US", options).format(
    new Date(inputDateTime),
  );
  return formattedDateTime;
};

export const duration = (timespan) => {
  if (timespan != null) {
    let [days, hms] = timespan.split(".");
    if (days == null) {
      let [hours, minutes, seconds] = timespan.split(":").map(Number);
      return `${days}Day ${hours}:${minutes}`;
    } else {
      let [hours, minutes, seconds] = hms.split(":").map(Number);
      return `${days}Day ${hours}hr ${minutes}min`;
    }
  } else {
    return "";
  }
};

export const formatCurrency = (value) => {
  if (value == null) return "";

  // Keep the negative sign if present
  const numeric = value.toString().replace(/[^0-9.-]/g, "");

  const number = parseFloat(numeric);
  if (isNaN(number)) return "";

  return number.toLocaleString("en-US");
};

// ---- Display helpers for dates coming from the API ----
// The API sends raw ISO values such as 2026-10-15T06:11:50.143. These turn them
// into readable text. Anything that is not an ISO date (text the server already
// formatted, a time span, a number) is returned unchanged, so they are safe on any value.
const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}(?:[T ]\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?(?:Z|[+-]\d{2}:?\d{2})?)?$/;
const toMoment = (value) => {
  if (value instanceof Date) return moment(value);
  if (typeof value !== "string" || !ISO_DATE_RE.test(value.trim())) return null;
  const m = moment(value.trim());
  return m.isValid() ? m : null;
};
// 15 Oct, 2026
export const displayDate = (value, fallback = "") => {
  if (value == null || value === "") return fallback;
  const m = toMoment(value);
  if (m == null) return value;
  if (m.year() < 1900) return fallback; // DateTime.MinValue / unset dates
  return m.format("DD MMM, YYYY");
};
// 15 Oct, 2026 6:11 AM (date only when there is no time part)
export const displayDateTime = (value, fallback = "") => {
  if (value == null || value === "") return fallback;
  const m = toMoment(value);
  if (m == null) return value;
  if (m.year() < 1900) return fallback;
  const hasTime = typeof value !== "string" || /[T ]\d{2}:\d{2}/.test(value);
  if (!hasTime || (m.hours() === 0 && m.minutes() === 0 && m.seconds() === 0)) {
    return m.format("DD MMM, YYYY");
  }
  return m.format("DD MMM, YYYY h:mm A");
};
// 6:11 AM (accepts an ISO date-time or a time such as 06:11:50)
export const displayTime = (value, fallback = "") => {
  if (value == null || value === "") return fallback;
  const m = toMoment(value);
  if (m != null) return m.format("h:mm A");
  if (typeof value === "string" && /^\d{1,2}:\d{2}(:\d{2}(\.\d+)?)?$/.test(value.trim())) {
    const tm = moment(value.trim(), ["HH:mm:ss.SSS", "HH:mm:ss", "HH:mm"]);
    if (tm.isValid()) return tm.format("h:mm A");
  }
  return value;
};

export const dateOnly = (value) => {
  let dstring = moment(value).format("YYYY-MM-DD");
  return dstring;
  //let d=new Date(dstring);
  //return d;
};

export function seo(data = {}) {
  data.title = data.title || "Lagos Judiciary";
  data.metaDescription = data.metaDescription || "Lagos Judiciary";

  document.title = data.title;
  document
    .querySelector('meta[name="description"]')
    .setAttribute("content", data.metaDescription);
}
export const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    if (file) {
      reader.readAsDataURL(file);
    }
    // reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });
export const getCookie = (key) => {
  var b = document.cookie.match("(^|;)\\s*" + key + "\\s*=\\s*([^;]+)");
  return b ? b.pop() : "";
};
export const AbsoluteFiletoRelative = (absolutepath) => {
  //first split from last appearance of resources
  if (absolutepath == null) return "";

  var tn = absolutepath.split("Resources");
  var relative = apiUrl.slice(0, -3) + "Resources" + tn[1].replace(/\\/g, "/");
  console.log("the file relative path");
  console.log(relative);
  return relative;
};
export const RelativeFiletoRelative = (relativepath) => {
  //first split from last appearance of resources
  if (relativepath == null) return "";

  var relative = docUrl + relativepath;
  return relative;
};
export const ReduceFilename = (filename) => {
  if (filename.length > 25) {
    var aa = filename.split(".");
    if (aa.length == 2) {
      //exact senerio
      var nn = aa[0].substring(0, 20) + "." + aa[1];
      return nn;
    } else {
      return aa[0] + "." + aa[aa.length - 1];
    }
  } else {
    return filename;
  }
};

export const ReduceString = (value, max) => {
  if (value == null) return "";

  if (value.length > max) {
    var s = value.substring(0, max);
    return s + "...";
  } else {
    return value;
  }
};
export const NoteExcept = (title) => {
  return title?.startsWith("NOTE");
};
const formatter = new Intl.NumberFormat(undefined, {
  style: "currency",
  currency: "NGN",

  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

export const RewriteLocalUrl = (localurl) => {
  let res = localurl.indexOf("Resources");
  let s = localurl.substring(res, localurl.length);
  return rooturl + "/" + s;
};
/* 
export const CalUnSpecified = (bignumber) => {
  var fixincamt = "5000000";
  var incrementval = "2500";
  var difffromstart = "100000000";
  var diff = bignumber - difffromstart;
  var res = 0;
  var finalamt = 0;
  res = diff / fixincamt;
  //res = Math.floor(res);
  if (res > 0) {
    if (res <= 1) {
      finalamt = 1 * parseInt(incrementval);
    } else {
      finalamt = Math.ceil(res) * parseInt(incrementval);
    }
  } else {
    finalamt = 0;
  }

  var feeamount = lastSpecified; //element 736 last value
  var calunspefamount = parseInt(feeamount) + parseInt(finalamt);
  return calunspefamount;
}; */
export const CalUnSpecified = (bignumber) => {
  // Use standard numbers (safe up to 9,007,199,254,740,991)
  const val = Number(bignumber);
  const BASE_THRESHOLD = 100000000;
  const BASE_FEE = 55000;
  const INCREMENT_STEP = 5000000;
  const INCREMENT_VALUE = 2500;

  // If below or equal to 100M, return base fee
  if (val <= BASE_THRESHOLD) {
    return BASE_FEE;
  }

  const diff = val - BASE_THRESHOLD;

  // Math.ceil handles the "step" logic
  // e.g., 50,000,000 / 5,000,000 = 10 steps
  const steps = Math.ceil(diff / INCREMENT_STEP);
  const totalFee = BASE_FEE + steps * INCREMENT_VALUE;

  return totalFee;
};

export const isNumber = (value) => {
  //console.log(`${typeof value} and the isNAN ${!Number.isNaN(value)}`)
  return !Number.isNaN(value);
};
export const Distinct = (arr) => {
  return Array.from(new Set(arr));
};

export const ReplaceAll = (str, str1, str2) => {
  //return str.replace(/replaceWhat/g,replaceTo);
  const ignore = true;
  return str.replace(
    new RegExp(
      str1.replace(/([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|\<\>\-\&])/g, "\\$&"),
      ignore ? "gi" : "g",
    ),
    typeof str2 == "string" ? str2.replace(/\$/g, "$$$$") : str2,
  );
};
export const CleanQuillHtml = (html) => {
  //replace all class="ql-align-center" to style="text-align:center"
  // class="ql-align-right" style="text-align:right"
};
/* export const DocPermissionList =new Set([
  182,183,184,685, 189,196,702,707,196,693,703,
  708,712,713,714,189, 244,261,570,441,312,
   22,25,38,64 //680 //remove 680 on live
])  */
export const DocPermissionList = new Set([
  183, 703, 707, 196, 200, 189, 243, 278, 693, 257, 576, 447, 318, 261, 576,
  447, 318, 583, 454, 325, 587, 458, 329, 15, 16, 22, 25, 35, 38, 39,
]);

export const DocPermissionList_ADR = new Set([
  42, 46, 55, 58, 88, 89, 101, 105, 119, 127, 147, 149, 154, 157, 158, 179,
]);
export const getAlphaByNum = (n) => {
  return String.fromCharCode(96 + n); //a is 96
};
export const getQueryString = (variable) => {
  var query = window.location.search.substring(1);
  console.log(query); //"app=article&act=news_content&aid=160990"
  var vars = query.split("&");
  console.log(vars); //[ 'app=article', 'act=news_content', 'aid=160990' ]
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    console.log(pair); //[ 'app', 'article' ][ 'act', 'news_content' ][ 'aid', '160990' ]
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return false;
};
export const getQuery = () => {
  var query = window.location.search.substring(1);
  console.log(query); //"app=article&act=news_content&aid=160990"

  return query;
};
export const Checkfiles = (fileName) => {
  //var fup = document.getElementById('filename');
  //var fileName = fup.value;
  var ext = fileName.substring(fileName.lastIndexOf(".") + 1);
  if (ext == "pdf") {
    return true;
  } else {
    return false;
  }
};
export const b64encode = (txt) => {
  return btoa(unescape(encodeURIComponent(txt)));
};
export const b64decode = (txt) => {
  return decodeURIComponent(escape(atob(txt)));
};

export const decodeBase64ToUtf8 = (base64) => {
  // Convert base64 → binary string
  const binary = atob(base64);

  // Convert binary string → bytes
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }

  // Decode bytes as UTF-8 text
  return new TextDecoder("utf-8").decode(bytes);
};

export const ConvertText = (str) => {
  // return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  return str.replace(/[^\x00-\x7F]/g, "");
};

export const QrCodelink = (str) => {
  return `https://quickchart.io/qr?text=${str}&size=100`;
};

export const TitleCase = (str) => {
  return str[0].toUpperCase() + str.slice(1).toLowerCase();
};
export const serverErr =
  "Could not connect to the service at the moment. Please try again.";
export const IsNull = (v) => {
  if (v == undefined || v == null) return true;
  else return false;
};

export const onScreenDetails = async (code, token) => {
  //for account registration
  try {
    const resp = await fetch(`${apiUrl}/profile/screens/${code}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await resp.json();
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const PageDetails = (data, type, code) => {
  if (type == "tab") {
    const found = data?.tabs?.find((el) => el.code === code);
    return found;
  } else if ((type = "action")) {
    const found = data?.actions.find((el) => el.code === code);
    return found;
  }
};
export const upsertObject = (prevObjs, newObj) => {
  const index = prevObjs.findIndex((obj) => obj.id === newObj.id);
  if (index !== -1) {
    // Update existing role
    return prevObjs.map((obj) =>
      obj.id === newObj.id ? { ...obj, ...newObj } : obj,
    );
  } else {
    // Insert new role
    return [...prevObjs, newObj];
  }
};

export const getItemById = (items, id) => {
  var item = items.find((r) => r.id == id);
  return item;
};

export const getLabelByValue = (items, value) => {
  var item = items.find((r) => r.value == value);
  return item ? item.label : "";
};
export const gender = [
  { label: "Male", value: "M" },
  { label: "Female", value: "F" },
];
export const maritalstatus = [
  { label: "Married", value: "M" },
  { label: "Single", value: "S" },
  { label: "Widow/Widower", value: "W" },
  { label: "Divorced", value: "D" },
];
/* if (response.ok) {
      // HTTP 200 or 201
      console.log('✅ Success:', result.message);
      // Show success alert or update UI
    } else if (response.status === 409) {
      // Conflict (duplicate)
      console.warn('⚠️ Duplicate:', result.message);
      // Show warning message to user
    } else if (response.status === 400) {
      // Bad request (validation)
      console.error('❌ Validation Error:', result.message);
    } else if (response.status === 404) {
      // Not found
      console.error('❌ Not Found:', result.message);
    } else {
      // Other error
      console.error('❌ Unexpected error:', result.message || 'Unknown error');
    } */

export const momentDate = (dateinfo) => {
  if (dateinfo == null) {
    return null;
  }
  let time = moment.utc(dateinfo).local();
  return time;
};
export const momentTime = (timeinfo) => {
  if (!timeinfo) return null;

  // Force parse as HH:mm (24-hour format)
  const time = moment.utc(timeinfo, "HH:mm", true); // true = strict mode
  return time.isValid() ? time : null;
};
export const cleanBase64 = (str) => {
  // Remove whitespace and newlines
  let cleaned = str.replace(/\s/g, "");

  // Fix URL-safe base64 (if backend uses it)
  cleaned = cleaned.replace(/-/g, "+").replace(/_/g, "/");

  // Add padding if missing
  while (cleaned.length % 4 !== 0) {
    cleaned += "=";
  }

  return cleaned;
};


const WORK_START_HOUR = 8;
const WORK_END_HOUR = 16; // 4pm
const SLA_DAY_MINUTES = 8 * 60; // 480 minutes
export const getSlaTimeLeft = (slaexpire, holidays = []) => {
  if (!slaexpire) return { due: false, text: "" };

  const now = moment();
  const expire = moment(slaexpire);

  const diffWorkingMinutes = getWorkingMinutesBetween(now, expire, holidays);

  if (diffWorkingMinutes <= 0) {
    const overdueMinutes = Math.abs(diffWorkingMinutes);

    const days = Math.floor(overdueMinutes / 480); // 8hrs x 60mins
    const remainingAfterDays = overdueMinutes % 480;
    const hours = Math.floor(remainingAfterDays / 60);
    const minutes = remainingAfterDays % 60;

    if (days > 0) {
      return { due: true, text: `OVERDUE - ${days}d ${hours}h` };
    } else if (hours > 0) {
      return { due: true, text: `OVERDUE - ${hours}h ${minutes}m` };
    } else {
      return { due: true, text: `OVERDUE - ${minutes}m` };
    }
  }

  const days = Math.floor(diffWorkingMinutes / 480); // 8hrs = 1 day
  const remainingAfterDays = diffWorkingMinutes % 480;
  const hours = Math.floor(remainingAfterDays / 60);
  const minutes = diffWorkingMinutes % 60;

  if (days > 0) {
    return { due: false, text: `${days}d ${hours}h LEFT` };
  } else if (hours > 0) {
    return { due: false, text: `${hours}h ${minutes}m LEFT` };
  } else {
    return { due: false, text: `${minutes}m LEFT` };
  }
};


const getWorkingMinutesBetween = (fromDate, toDate, holidays = []) => {
  const from = moment(fromDate);
  const to = moment(toDate);

  if (from.isSame(to)) return 0;

  const isFuture = to.isAfter(from);

  const start = isFuture ? from.clone() : to.clone();
  const end = isFuture ? to.clone() : from.clone();

  let totalMinutes = 0;
  let cursor = start.clone().startOf("day");

  while (cursor.isSameOrBefore(end, "day")) {
    if (!isHoliday(cursor, holidays)) {
      const workStart = cursor.clone().hour(WORK_START_HOUR).minute(0).second(0).millisecond(0);
      const workEnd = cursor.clone().hour(WORK_END_HOUR).minute(0).second(0).millisecond(0);

      const rangeStart = moment.max(start, workStart);
      const rangeEnd = moment.min(end, workEnd);

      if (rangeEnd.isAfter(rangeStart)) {
        totalMinutes += rangeEnd.diff(rangeStart, "minutes");
      }
    }

    cursor.add(1, "day");
  }

  return isFuture ? totalMinutes : -totalMinutes;
};

const isHoliday = (date, holidays = []) => {
  if (!holidays || holidays.length === 0) return false;

  return holidays.some(h => {
    if (!h.isActive) return false;

    const holidayStart = moment(h.startDate).startOf("day");
    const holidayEnd = moment(h.endDate).endOf("day");

    return date.isBetween(holidayStart, holidayEnd, "day", "[]");
  });
};
export const getDocumentPath = (docs) => {
    // Check if documentLocation exists and is not empty
    if (docs.documentLocation && docs.documentLocation.trim() !== '') {
        // Check if documentLocation is already in filename
        if (docs.filename && docs.filename.includes(docs.documentLocation)) {
            return docs.filename;
        }
        // Otherwise combine them
        return `${docs.documentLocation}/${docs.filename}`;
    }
    
    // If documentLocation is empty or null, return only filename
    return docs.filename;
}
